import React from 'react';

export type MenuItem = {
  key: string;
  label: string;
  icon?: React.ReactNode;
};

type Props = {
  items: MenuItem[];
  activeKey?: string;
  onSelect: (key: string) => void;
};

export const Sidebar: React.FC<Props> = ({ items, activeKey, onSelect }) => {
  return (
    <div className="h-full w-64 border-r bg-card/50">
      <div className="flex h-14 items-center gap-2 border-b px-4">
        <img src="/logo512.png" alt="logo" className="h-6 w-6" />
        <div className="text-sm font-semibold">VM Charm Admin</div>
      </div>
      <div className="p-3 text-xs font-semibold text-muted-foreground">MENU</div>
      <nav className="flex flex-col">
        {items.map(it => {
          const active = activeKey === it.key;
          return (
            <button
              key={it.key}
              className={`group relative flex items-center gap-3 px-4 py-2.5 text-left text-sm transition-colors hover:bg-accent ${active ? 'border-l-2 border-primary bg-accent/60 font-medium' : ''}`}
              onClick={() => onSelect(it.key)}
            >
              <span className={`shrink-0 ${active ? 'text-foreground' : 'text-muted-foreground group-hover:text-foreground'}`}>{it.icon}</span>
              <span className="truncate">{it.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default Sidebar;
